import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AppContext from 'context/Context';
import { getAppPageContainerShellStyle, PAGE_CONTAINER_MODE } from 'config';

/**
 * Dashboard page shell: `.layout-container` + width/max-width from settings.
 * Horizontal gutters are defined in `_app-containers.scss` (not inline), so they
 * are not overridden by `getAppPageContainerShellStyle`.
 *
 * Prefer this over Bootstrap `Container` so layout follows app settings without duplicate gutters.
 *
 * Optional `mode` / `maxWidthPx` for full-bleed or special previews.
 */
const AppPageContainer = ({
  children,
  className,
  style,
  mode: modeProp,
  maxWidthPx: maxWidthPxProp,
}) => {
  const {
    config: { pageContainerMode, pageContainer },
  } = useContext(AppContext);

  const shellMode = modeProp ?? pageContainerMode;
  const maxWidthPx =
    maxWidthPxProp ?? pageContainer?.maxWidthPx ?? 1800;

  const shellStyle = getAppPageContainerShellStyle(shellMode, maxWidthPx);

  return (
    <div className='' style={{minHeight: '100vh'}} >
      <div className={classNames('layout-container', className)} style={{ ...shellStyle, ...style }} >
        {children}
      </div>
    </div>
  );
};

AppPageContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  mode: PropTypes.oneOf([PAGE_CONTAINER_MODE.FLUID, PAGE_CONTAINER_MODE.BOXED]),
  maxWidthPx: PropTypes.number,
};

export default AppPageContainer;
